import decode from 'jwt-decode';
import React, { Component } from "react";
import ReactDOM from "react-dom";
import ScrollArea from "react-scrollbar";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {constants} from '../common/commonExport';
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/src/SuperResponsiveTableStyle.css";

class AuthService extends React.Component {
  constructor(props) {
    super(props);
    this.domain = constants.baseUrl // API server domain
    this.fetch = this.fetch.bind(this) // React binding stuff
    this.login = this.login.bind(this)
    this.getProfile = this.getProfile.bind(this);
  }

  login(username, password, impersonateUserId) {
    // Get a token from api server using the fetch api
    return this.fetch(`${this.domain}/login` + "?_= " + new Date().getTime(), {
        method: 'POST',
        body: JSON.stringify({
            username,
            password,
            impersonateUserId
        })
    }, username, password, impersonateUserId).then(res => {
        this.setToken(res.id_token) // Setting the token in localStorage
        return Promise.resolve(res);
    })
}

loggedIn() {
    // Checks if there is a saved token and it's still valid
    const token = this.getToken() // GEtting token from localstorage
    return !!token && !this.isTokenExpired(token) // handwaiving here
}

isTokenExpired(token) {
    try {
        const decoded = decode(token);        
        if (decoded.exp < Math.floor(Date.now() / 1000)) { // Checking if token is expired. N
            alert("Your token has expired. Please log in again")
            return true;
        }
        else {
            return false;
        }
    }
    catch (err) {
        return false;
    }
}

setToken(idToken) {
    // Saves user token to localStorage
    localStorage.setItem('id_token', idToken)
}

getToken() {
    // Retrieves the user token from localStorage
    return localStorage.getItem('id_token')
}

logout() {
    // Clear user token and profile data from localStorage
    localStorage.removeItem('id_token');
}

getProfile() {
    // Using jwt-decode npm package to decode the token
    return decode(this.getToken());
}


fetch(url, options,username,password, impersonateUserId) {
    var self = this;
    // performs api calls sending the required authentication headers
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
    // Setting Authorization header
    // Authorization: Bearer xxxxxxx.xxxxxxxx.xxxxxx
    if (this.loggedIn()) {
        headers['Authorization'] = 'Bearer ' + this.getToken()
    }

    return fetch(url, {
        headers,
        method: 'POST',
        body: JSON.stringify({
            username,
            password,
            impersonateUserId
        })
    })
        .then(self.checkStatus)
        .then(response => response.json())
}

checkStatus(response) {
    // raises an error in case response status is not a success
    if (response.status >= 200 && response.status < 300) { // Success status lies between 200 to 300
        return response
    } else {
        var error = new Error(response)
        error.response = response
        throw error
    }
}
}


export default AuthService;